import UploadIcon from "../icons/NetworkStats/UploadIcon"
import DownloadIcon from "../icons/NetworkStats/DownloadIcon"
import RefreshIcon from "../icons/NetworkStats/RefreshIcon"
import RefreshCheck from "../icons/NetworkStats/RefreshCheck"
import { getNetworkStats } from "@videosdk.live/react-sdk";
import WifiOff from "../icons/NetworkStats/WifiOff";
import { useEffect, useState } from "react";
import useIsMobile from "../hooks/useIsMobile";

const NetworkStats = ({ }) => {
  const [error, setError] = useState("no-error-loading")
  const [uploadSpeed, setUploadSpeed] = useState(null)
  const [downloadSpeed, setDownloadSpeed] = useState(null)
  const isMobile = useIsMobile()

  useEffect(() => { getNetworkStatistics(); }, [])

  const getNetworkStatistics = async () => {
    setError("no-error-loading");
    try {
      const options = { timeoutDuration: 45000 }; // Set a custom timeout of 45 seconds
      const networkStats = await getNetworkStats(options);
      if (networkStats) {
        setError("no-error");
      }
      setDownloadSpeed(networkStats["downloadSpeed"]);
      setUploadSpeed(networkStats["uploadSpeed"])
    } catch (ex) {
      if (ex === "Not able to get NetworkStats due to no Network") {
        setError("no-wifi")
      }
      if (ex === "Not able to get NetworkStats due to timeout") {
        setError("timeout")
      }
      console.log("Error in networkStats: ", ex);
    }
  }

  const handleOnClick = () => {
    getNetworkStatistics()
  }

  return (
    <div className="flex flex-row items-center bg-white border border-violet-200 rounded-xl shadow-sm px-3 py-2 min-h-[2.5rem]">

      {error === "no-error-loading" &&
        <div className="flex items-center gap-2 text-xs text-violet-600">
          <RefreshCheck />
          <span>Checking network speeds...</span>
        </div>
      }

      {error === "no-error" &&
        <>
          <div className="flex items-center gap-2 text-xs text-violet-700 px-2">
            <DownloadIcon />
            <span className="font-medium">{downloadSpeed} MBPS</span>
          </div>
          <div className="w-px h-4 bg-violet-200 mx-1"></div>
          <div className="flex items-center gap-2 text-xs text-violet-700 px-2">
            <UploadIcon />
            <span className="font-medium">{uploadSpeed} MBPS</span>
          </div>
          <div className="w-px h-4 bg-violet-200 mx-1"></div>
          <button
            className="flex items-center justify-center p-1 hover:bg-violet-100 rounded-lg transition-colors"
            onClick={handleOnClick}
            title="Refresh network stats"
          >
            <RefreshIcon />
          </button>
        </>
      }

      {error === "no-wifi" &&
        <>
          <div className="flex items-center gap-2 text-xs text-red-600 px-2">
            <WifiOff />
            <span className="font-medium">You're offline! Check your connection</span>
          </div>
          <div className="w-px h-4 bg-violet-200 mx-1"></div>
          <button
            className="flex items-center justify-center p-1 hover:bg-violet-100 rounded-lg transition-colors"
            onClick={handleOnClick}
            title="Retry connection"
          >
            <RefreshIcon />
          </button>
        </>
      }

      {error === "timeout" &&
        <>
          <div className="flex items-center gap-2 text-xs text-red-600 px-2">
            <span className="font-medium">Something went wrong! Couldn't load data</span>
          </div>
          <div className="w-px h-4 bg-violet-200 mx-1"></div>
          <button
            className="flex items-center justify-center p-1 hover:bg-violet-100 rounded-lg transition-colors"
            onClick={handleOnClick}
            title="Retry loading"
          >
            <RefreshIcon />
          </button>
        </>
      }

    </div>
  )
}

export default NetworkStats